export default {
  props: {
    size: { default: "small" },
    hasFooter: { default: true },
    labels: {
      type: Object,
      default() {
        return {
          cancel: "Cancelar",
          submit: "Salvar"
        };
      }
    },
    submit: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: "light"
    },
    sidebar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      closing: false,
      isOpen: true
    };
  },
  mounted() {
    this.hiddenScroll();
    EventBus.$on("modal-close", () => {
      this.closeModal();
    });
    document.documentElement.addEventListener(
      "keydown",
      this.closeWithKeyboard
    );
  },
  beforeDestroy() {
    this.showScroll();
    document.documentElement.removeEventListener(
      "keydown",
      this.closeWithKeyboard
    );
  },
  computed: {
    hasHeader() {
      return typeof this.$slots.header !== "undefined";
    },
    modalClasses() {
      return {
        "is-extrasmall": this.size === "extrasmall",
        "is-small": this.size === "small",
        "is-large": this.size === "large",
        "is-medium": this.size === "medium",
        "is-closing": this.closing,
        "is-naked": typeof this.$slots.header === "undefined" && !this.hasFooter
      };
    }
  },
  methods: {
    buttonStyle(button) {
      if (typeof button !== "string") {
        return `color: ${this.buttonColor(
          button
        )}; background-color: ${this.buttonBackground(button)}`;
      }
      return "";
    },
    buttonColor(button) {
      if (typeof button !== "string") {
        return button.color;
      }
      return "#898989";
    },
    buttonBackground(button) {
      if (typeof button !== "string") {
        return button.background;
      }
      return "rgba(0,0,0,0.05)";
    },
    buttonLabel(button) {
      if (typeof button !== "string") {
        return button.text;
      }
      return button;
    },
    closeWithKeyboard(e) {
      if (e.keyCode === 27) {
        this.closeModal();
      }
    },
    showScroll() {
      document.documentElement.setAttribute("class", "");
    },
    hiddenScroll() {
      document.documentElement.setAttribute("class", "has-modal");
    },
    saveChanges() {
      // TODO: Emmit a event with the changes
      this.$emit("save");
    },
    closeModal() {
      this.closing = true;
      setTimeout(() => {
        this.showScroll();
        this.$emit("close");
      }, 300);
    }
  }
};
